export default "__VITE_PUBLIC_ASSET__ac8f42cb__"